import { get, post, remove} from "../common/http.services";

export function getCustomer(searchText: string, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return get(`/customer?searchText=${searchText}&page=${pageNumber}&size=${pageSize}&sort=name,asc`, appContext, success, error);
}

export function saveCustomer(customerModel: any, appContext: any, success: any, error: any) {
    return post(`/customer`, customerModel, appContext, success, error);
}

export function deleteCustomer(id: any, appContext: any, success: any, error: any) {
    return remove(`/customer?id=${id}`, appContext, success, error);
}

export function getCustomerById(id: any, appContext: any, success: any, error: any) {
    return get(`/customer/findbyid?id=${id}`, appContext, success, error);
}

